import { FC } from 'react';
import { Box, BoxProps } from '@mui/material';

import { TabContextProviderProps } from '@components/base';

import TabContextProvider from './useTabContext/provider';
import { TabButtons } from './TabButtons';
import { TabPanels } from './TabPanels';

export type TabsProps = TabContextProviderProps & {
  tabRowWrapperProps?: BoxProps;
  wrapperProps?: BoxProps;
};

export const Tabs: FC<TabsProps> = ({
  onTabChange,
  selectedTab,
  tabRowWrapperProps,
  tabs,
  buttonVariant = 'standard',
  wrapperProps: { width = 1, ...wrapperProps } = {},
}) => (
  <TabContextProvider
    buttonVariant={buttonVariant}
    onTabChange={onTabChange}
    selectedTab={selectedTab}
    tabs={tabs}
  >
    <Box width={width} {...wrapperProps}>
      <TabButtons tabRowWrapperProps={tabRowWrapperProps} />
      <TabPanels />
    </Box>
  </TabContextProvider>
);
